import { render } from "./addPersonnel.vue?vue&type=template&id=139e97be&scoped=true"
import script from "./addPersonnel.vue?vue&type=script&lang=js"
export * from "./addPersonnel.vue?vue&type=script&lang=js"

import "@/assets/css/add.css?vue&type=style&index=0&id=139e97be&scoped=true&lang=css&external"
import "./addPersonnel.vue?vue&type=style&index=1&id=139e97be&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-139e97be"]])

export default __exports__